// istanbul ignore file
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface KpiList {
  kpi_definition_id: string
  kpi_name: string
  kpi_description: string
  is_custom_kpi?: boolean
  totalizer_type?: string
}
export interface DeviceKpiListState {
  isLoading: boolean
  loadingError: string | null
  kpiList: KpiList[] | null
  kpiCount: number
  httpStatus: number | null
}
const initialState: DeviceKpiListState = {
  isLoading: true,
  loadingError: null,
  kpiList: null,
  kpiCount: 0,
  httpStatus: null
}

const deviceKpiListSlice = createSlice({
  name: 'deviceKpiListSlice',
  initialState,
  reducers: {
    deviceKpiListLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        kpiList: null,
        kpiCount: 0,
        httpStatus: 0
      }
    },
    deviceKpiListUpdateAction: (state, action: PayloadAction<{ data: KpiList[], count: number, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        kpiList: action.payload.data,
        kpiCount: action.payload.count,
        httpStatus: action.payload.httpStatus
      }
    },
    deviceKpiListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        kpiList: null,
        kpiCount: 0,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  deviceKpiListLoadingAction,
  deviceKpiListUpdateAction,
  deviceKpiListErrorAction
} = deviceKpiListSlice.actions

export default deviceKpiListSlice.reducer
